var _desc, _rect, _path, _path2, _rect2, _g, _path3, _path4, _g2, _circle, _path5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle2, _g3, _circle3, _rect10, _rect11, _rect12, _ellipse, _ellipse2, _g4, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path6, _g5, _rect20, _rect21, _polyline, _rect22, _circle4, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _g6, _rect30, _polyline2, _circle5, _path7, _polyline3, _rect31, _rect32, _ellipse3, _ellipse4, _path8, _path9, _rect33, _path10, _circle6, _rect34, _circle7, _path11, _circle8, _path12, _path13, _path14, _path15, _rect35, _rect36, _rect37, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginRpm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    role: "img",
    "aria-labelledby": titleId,
    preserveAspectRatio: "xMinYMid slice",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "rpmTitle"
  }, "Remote patient monitoring illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "rpmTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "rpmDesc"
  }, "A cellular blood-pressure cuff and a weight scale send readings through the cellular network to a clinician dashboard showing a pulse line and a trend chart, reviewed by a care-team nurse.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M905 0C880 80 960 170 930 240C900 300 810 320 795 400C770 500 860 560 960 650C1040 730 1060 800 1050 900C1045 960 1035 1030 1055 1080H1920V0Z",
    fill: "#0c41a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 560C60 380 180 230 360 220C540 210 760 260 790 420C820 600 760 800 560 850C360 900 110 820 80 560Z",
    fill: "#e6ecf6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 896,
    width: 760,
    height: 40,
    rx: 20,
    fill: "#d6e0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0c41a6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "2 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 405C270 330 320 300 388 300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 640C280 600 250 340 392 312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 336V370"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432 366L440 378L448 366Z",
    fill: "#0c41a6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M395 330a22 22 0 0 1 6-44a32 32 0 0 1 60-8a25 25 0 0 1 22 52Z",
    fill: "#cfdbef"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0044ad"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 306,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 300,
    width: 8,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 293,
    width: 8,
    height: 23,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 286,
    width: 8,
    height: 30,
    rx: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 430,
    r: 80,
    fill: "#ffffff",
    stroke: "#d6e0f0",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126 438C128 420 146 414 164 424",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 436,
    width: 80,
    height: 52,
    rx: 14,
    fill: "#0044ad"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 446,
    width: 34,
    height: 32,
    rx: 6,
    fill: "#0c41a6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 448,
    width: 9,
    height: 28,
    rx: 3,
    fill: "#cfdbef"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 392,
    width: 60,
    height: 74,
    rx: 10,
    fill: "#e6ecf6",
    stroke: "#3f3d56",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 401,
    width: 44,
    height: 30,
    rx: 4,
    fill: "#1d2366"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 408,
    width: 24,
    height: 5,
    rx: 2,
    fill: "#cfdbef"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 418,
    width: 32,
    height: 5,
    rx: 2,
    fill: "#bbcde8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 448,
    r: 8,
    fill: "#0044ad"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0c41a6",
    strokeWidth: 4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228 384a10 10 0 0 1 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 372a22 22 0 0 1 22 22"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 660,
    r: 80,
    fill: "#ffffff",
    stroke: "#d6e0f0",
    strokeWidth: 6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 610,
    width: 104,
    height: 104,
    rx: 20,
    fill: "#ffffff",
    stroke: "#3f3d56",
    strokeWidth: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 622,
    width: 48,
    height: 20,
    rx: 4,
    fill: "#1d2366"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 629,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#cfdbef"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132,
    cy: 680,
    rx: 12,
    ry: 20,
    fill: "#cfdbef"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168,
    cy: 680,
    rx: 12,
    ry: 20,
    fill: "#cfdbef"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0c41a6",
    strokeWidth: 4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208 600a10 10 0 0 1 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 588a22 22 0 0 1 22 22"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 620,
    width: 360,
    height: 14,
    rx: 6,
    fill: "#1d2366"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 634,
    width: 12,
    height: 264,
    fill: "#1d2366"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 634,
    width: 12,
    height: 264,
    fill: "#1d2366"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 598,
    width: 30,
    height: 24,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 612,
    width: 90,
    height: 10,
    rx: 5,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 380,
    width: 300,
    height: 222,
    rx: 14,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 394,
    width: 272,
    height: 194,
    rx: 6,
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304 418V400a6 6 0 0 1 6-6H570a6 6 0 0 1 6 6V418Z",
    fill: "#0044ad"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#cfdbef"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 406,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 406,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 406,
    r: 4
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 402,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#e6ecf6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 428,
    width: 160,
    height: 66,
    rx: 6,
    fill: "#e6ecf6"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "322,462 350,462 360,446 372,480 384,436 396,470 404,462 466,462",
    fill: "none",
    stroke: "#0c41a6",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 428,
    width: 82,
    height: 30,
    rx: 6,
    fill: "#d6e0f0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 497,
    cy: 443,
    r: 6,
    fill: "#0044ad"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 437,
    width: 48,
    height: 5,
    rx: 2,
    fill: "#ffffff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 446,
    width: 32,
    height: 5,
    rx: 2,
    fill: "#ffffff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 464,
    width: 82,
    height: 30,
    rx: 6,
    fill: "#d6e0f0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 491,
    y: 472,
    width: 13,
    height: 13,
    rx: 3,
    fill: "#1d2366"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 473,
    width: 44,
    height: 5,
    rx: 2,
    fill: "#ffffff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 482,
    width: 28,
    height: 5,
    rx: 2,
    fill: "#ffffff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 504,
    width: 252,
    height: 74,
    rx: 6,
    fill: "#ffffff",
    stroke: "#e6ecf6",
    strokeWidth: 3
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#bbcde8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 546,
    width: 16,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 536,
    width: 16,
    height: 34,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 550,
    width: 16,
    height: 20,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 530,
    width: 16,
    height: 40,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 540,
    width: 16,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 526,
    width: 16,
    height: 44,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 534,
    width: 16,
    height: 36,
    rx: 3
  }))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 524,
    y: 518,
    width: 16,
    height: 52,
    rx: 3,
    fill: "#0044ad"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "336,532 364,522 392,536 420,516 448,526 476,512 504,520 532,506",
    fill: "none",
    stroke: "#0c41a6",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 506,
    r: 5,
    fill: "#cf6f80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M700 420C632 376 630 312 668 306C685 303 698 314 700 328C702 314 715 303 732 306C770 312 768 376 700 420Z",
    fill: "#0044ad"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "664,350 682,350 690,334 700,374 710,340 716,352 736,352",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 716,
    width: 26,
    height: 170,
    rx: 8,
    fill: "#1d2366"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 698,
    y: 716,
    width: 26,
    height: 170,
    rx: 8,
    fill: "#1d2366"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676,
    cy: 890,
    rx: 20,
    ry: 9,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 714,
    cy: 890,
    rx: 20,
    ry: 9,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M656 576C666 562 724 562 734 576L744 724C710 736 680 736 646 724Z",
    fill: "#0c41a6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M682 566L695 596L708 566Z",
    fill: "#ffffff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 622,
    width: 18,
    height: 10,
    rx: 2,
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M686 570C676 610 682 640 700 646C716 640 718 616 712 590",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 712,
    cy: 590,
    r: 5,
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 548,
    width: 16,
    height: 22,
    rx: 4,
    fill: "#ffb0b1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 696,
    cy: 528,
    r: 28,
    fill: "#ffb0b1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M668 528C664 498 688 488 706 494C724 498 730 516 724 534C716 518 700 510 684 514C676 518 672 524 668 528Z",
    fill: "#591d4b"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 726,
    cy: 508,
    r: 13,
    fill: "#591d4b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M662 586L618 640",
    stroke: "#0c41a6",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M618 640L584 560",
    stroke: "#ffb0b1",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M736 588L756 660",
    stroke: "#0c41a6",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M756 660L738 708",
    stroke: "#ffb0b1",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 676,
    width: 34,
    height: 46,
    rx: 5,
    fill: "#ffffff",
    stroke: "#3f3d56",
    strokeWidth: 3
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 686,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#bbcde8"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 696,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#bbcde8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(215 896) scale(0.8) translate(-152 -896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 838H178L172 896H132Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 850,
    width: 48,
    height: 4,
    fill: "#cfdbef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 860,
    width: 46,
    height: 4,
    fill: "#cfdbef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 838V770",
    stroke: "#3f3d56",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 800C120 806 96 790 84 764C114 762 140 776 152 800Z",
    fill: "#0044ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 788C182 794 204 776 214 748C184 748 162 764 152 788Z",
    fill: "#0044ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 772C140 752 142 732 158 716C166 736 164 756 152 772Z",
    fill: "#0c41a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRpm);
export default __webpack_public_path__ + "static/media/loginRPM.997d2dcb348b003f728761df35fa3f8f.svg";
export { ForwardRef as ReactComponent };